import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Printer, Award } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

const LEVEL_LABELS = { membros: "Membros", coordenadores: "Coordenadores", direcao: "Direção" };

export default function Certificate() {
  const { id } = useParams();
  const { user } = useAuth();
  const [cert, setCert] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!user) return;
    api.get(`/me/courses/${id}/certificate`)
      .then((r) => setCert(r.data))
      .catch((e) => setError(e.response?.data?.detail || "Não foi possível emitir o certificado."));
  }, [id, user]);

  if (error) {
    return (
      <div className="max-w-lg mx-auto px-4 py-24 text-center">
        <h1 className="font-display font-semibold text-2xl text-th-blue">Certificado indisponível</h1>
        <p className="mt-2 text-slate-500">{error}</p>
        <Button asChild variant="outline" className="mt-6 border-slate-300 text-th-blue"><Link to={`/escola/${id}`}>Voltar ao curso</Link></Button>
      </div>
    );
  }
  if (!cert) return <div className="max-w-4xl mx-auto px-4 py-20 text-slate-500">A emitir…</div>;

  const dateStr = new Date(cert.date).toLocaleDateString("pt-PT", { day: "2-digit", month: "long", year: "numeric" });

  return (
    <div className="bg-slate-100 min-h-[calc(100vh-4rem)] py-10 px-4 print:bg-white print:p-0">
      <div className="max-w-3xl mx-auto flex justify-between items-center mb-6 print:hidden">
        <Button asChild variant="ghost" className="text-th-blue"><Link to={`/escola/${id}`}><ArrowLeft className="w-4 h-4 mr-1" />Voltar ao curso</Link></Button>
        <Button onClick={() => window.print()} className="bg-th-blue text-white hover:bg-th-bluelight" data-testid="print-certificate-btn"><Printer className="w-4 h-4 mr-2" />Imprimir / Guardar PDF</Button>
      </div>

      <div className="max-w-3xl mx-auto bg-white shadow-xl print:shadow-none" data-testid="certificate">
        <div className="border-[10px] border-th-blue m-3 print:m-0">
          <div className="border border-th-gold m-2 p-10 sm:p-14 text-center relative">
            <div className="flex justify-center"><Logo size={56} /></div>
            <p className="mt-6 text-xs uppercase tracking-[0.3em] text-th-gold font-semibold">Escola de Formação</p>
            <h1 className="mt-3 font-display font-bold text-3xl sm:text-4xl text-th-blue">Certificado de Conclusão</h1>
            <p className="mt-8 text-slate-500">Certifica-se que</p>
            <p className="mt-2 font-display font-semibold text-2xl sm:text-3xl text-th-bluedark" data-testid="cert-name">{cert.name}</p>
            <p className="mt-6 text-slate-500 max-w-xl mx-auto">concluiu com aproveitamento todos os {cert.modules_count} módulos do curso</p>
            <p className="mt-2 font-display font-semibold text-xl text-th-blue" data-testid="cert-course">«{cert.course_title}»</p>
            <p className="mt-1 text-sm text-slate-400">Nível: {LEVEL_LABELS[cert.level] || cert.level}</p>
            <div className="mt-10 flex items-center justify-center gap-2 text-th-gold"><Award className="w-6 h-6" /></div>
            <div className="mt-8 flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-slate-500">
              <span>{dateStr}</span>
              <span className="font-display text-th-blue">Terço dos Homens Mãe Rainha · Europa</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
